module.exports = __webpack_public_path__ + "media/images/emblems/Gunzgen-blason-8014cd26291ebea26d32e66ae4f94522.png";